import { createRef, FC } from 'react'
import { Form, CheckPicker } from 'rsuite';
import { SelectOptions } from 'core/models/Settings'
import { ItemDataType } from 'rsuite/esm/@types/common';

interface Meta {
  touched: boolean;
  error: string;
}

interface ComponentProps {
  input: any;
  placeholder: string;
  meta?: Meta;
  options: SelectOptions[];
  label?: string;
  searchable: boolean;
  disabled?: boolean;
  cleanable?: boolean;
  groupBy?: string;
  containerRef: any;
  name: string;
}

function handleLabel(data: ItemDataType | ItemDataType[]) {
  if (Array.isArray(data)) {
    if (data.length) {
      return <>{data[0].label}{data.length > 1 && <span className='rs-picker-value-count'>{data.length}</span>}</>
    }
    return null
  }
  return data?.label || null
}

const CustomSelect: FC<ComponentProps> = ({ placeholder, input, options, searchable, disabled, cleanable, groupBy, containerRef }) => (
  <CheckPicker
    searchable={searchable}
    block
    placeholder={placeholder}
    data={options}
    disabled={disabled}
    cleanable={cleanable}
    groupBy={groupBy}
    value={Array.isArray(input?.value) ? input.value : []}
    onChange={(newValue, eve) => input.onChange(newValue, eve)}
    renderValue={(_, item) => handleLabel(item)}
    container={() => containerRef.current}
  />
)

const MultiSelect: FC<ComponentProps> = (props: ComponentProps) => {
  const {
    placeholder = "Select",
    meta,
    input,
    label,
    options,
    searchable = false,
    disabled,
    cleanable = false,
    groupBy = '',
    name = 'multi-select',
  } = props
  const divRef = createRef<HTMLDivElement>();
  return (
    <Form.Group>
      <Form.ControlLabel>{label}</Form.ControlLabel>
      <div style={{ position: 'relative' }} ref={divRef}>
        <Form.Control
          name={`${name}-form-control`}
          placeholder={placeholder}
          accepter={CustomSelect}
          input={input}
          options={options}
          disabled={disabled}
          groupBy={groupBy}
          searchable={searchable}
          cleanable={cleanable}
          errorMessage={meta?.touched && meta.error}
          containerRef={divRef}
        />
      </div>
    </Form.Group>
  );
}

export default MultiSelect